module.exports = __webpack_public_path__ + "img/yilabao.204eb5f4.jpg";